module.exports = __webpack_public_path__ + "static/img/CgoRC2ORiMSAHgM9AA0sXV1NFQw875.a1423fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2ORiMSAHgM9AA0sXV1NFQw875.png
// module id = S3df
// module chunks = 73